import { useMutation } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { QUERY_KEYS } from '../constants';
import { API_ROUTES } from '../constants/apiRoutes';
import { useInvalidateQuery } from '../hooks/useInvalidateQuery';
import useLocalization from '../hooks/useLocalization';
import type { FirstDepositBonusResponse } from '../types/bonus';
import { postData } from '../utils/api';

type UseForfeitFirstDepositBonusOptions = {
  onSuccess?: (bonus: FirstDepositBonusResponse | null) => void;
};

export const useForfeitFirstDepositBonus = (options: UseForfeitFirstDepositBonusOptions = {}) => {
  const invalidateQuery = useInvalidateQuery();
  const { t } = useLocalization();

  return useMutation({
    mutationFn: (bonusId: string): Promise<FirstDepositBonusResponse | null> =>
      postData(API_ROUTES.FIRST_DEPOSIT_BONUS.FORFEIT, { bonusId }, 'wallet'),
    onSuccess: (bonus) => {
      invalidateQuery([QUERY_KEYS.firstDepositBonus, QUERY_KEYS.balance]);
      enqueueSnackbar(t('bonusSuccessfullyForfeited'), { variant: 'success' });
      options.onSuccess?.(bonus);
    },
    onError: () => {
      enqueueSnackbar(t('unableToForfeitBonus'), { variant: 'error' });
    },
  });
};
